export default "__VITE_ASSET__NnBnh1gp__"